import styled from 'styled-components';

export const ReceiverContactsSkeletons = styled.div`
  display: grid;
  gap: 12px;
  padding-right: 6px;

  .receiver-card-skeleton {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid
      ${({ theme }) => theme.colors.passwordValidationMarker.backgroundColor};
    background: ${({ theme }) => theme.colors.namedColors.white};
  }
`;
